import React from 'react';
import { Search, MoreVertical, Home, ArrowLeft, Files } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import BottomNav from '../../components/BottomNav.tsx';
import ActionDropdown from '../../components/ActionDropdown.tsx';
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";

interface VehicleModel {
  id: number;
  name: string;
  image: string;
  type: string;
  
}

const vehicleData = [
  {id: 1, name: '12 Meter EVS 2024', type: 'Work Instructions', image: digitalOceanImageUrl("assets/images/Bus-illustration.png") },
  { id: 2, name: '11 Meter EVS 2024', type: 'Work Instructions', image: digitalOceanImageUrl("assets/images/c.jpg") },
  { id: 3, name: '13 Meter EVS 2024', type: 'Work Instructions', image: digitalOceanImageUrl("assets/images/a.png") },
  {id: 4, name: '6.5 Meter EVS 2024', type: 'Work Instructions', image: digitalOceanImageUrl("assets/images/b.png")},
  {id: 5, name: '9 Meter EVS 2024',   type: 'Work Instructions', image: digitalOceanImageUrl("assets/images/c.jpg")},
  {id: 6, name: '7 Meter EVS 2024',   type: 'Work Instructions', image: digitalOceanImageUrl("products/kayoola_evs/images/orange.png")},
  {id: 7, name: '8 Meter EVS 2024',   type: 'Work Instructions', image: digitalOceanImageUrl("database_assets/products/Bus%20images/Kayoola%20EVS%202023%2010m%201.1.jpg")},
  {id: 8, name: '10 Meter EVS 2024',  type: 'Work Instructions', image: digitalOceanImageUrl("database_assets/products/Bus%20images/Kayoola%20EVS%202023%2012m%201.png")},

];
const VehicleInstructionsPage: React.FC<{ vehicleId: string }> = ({ vehicleId }) => {
  const {id} = useParams<{ id: string }>();
  const navigate = useNavigate();

  const vehicle = vehicleData.find((v) => v.id === Number(id));
   
  const vehicleTitle = vehicle ? vehicle.name : "Unknown Vehicle Model";
  const vehicleImage = vehicle ? vehicle.image : "https://via.placeholder.com/150";

  const workStations = [
    { id: 1, type:'body-shop' , title: 'Body Shop Model 1 Work Instructions' },
    { id: 2, type:'chassis-line', title: 'Chassis Line Model 1 Work Instructions' },
    { id: 3, type:'paint-shop' ,title: 'Paint Shop Model 1 Work Instructions' },
    { id: 4, type:'trim-line', title: 'Trim Line Model 1 Work Instructions' },
    { id: 5, type: 'QIT', title: 'QIT Model 1 Work Instructions' },
  ];

  const workInstructions = [
    { id: 1, type: 'body-shop', title: 'Body Shop Model'},
    { id: 2, type: 'chassis-line', title: 'chassis Line Model'},
    { id: 3, type: 'paint-shop', title: 'Paint Shop Model'},
  ]
  

  return (
    <div className="min-h-screen bg-blue-900 pb-20">
      {/* Header */}
      <div className="p-4 "><img src={digitalOceanImageUrl("new%20logos/Asset%204.png")} alt="KMC Logo" className="w-16 h-auto ml-auto h-24 w-27 " />  </div>
      <div className="p-6 flex justify-between items-center">
        <h1 className="text-white text-lg font-medium">
          {vehicleTitle} | Work Instructions
        </h1>
      </div>

      {/* Search Bar */}
      <div className="px-6 mb-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Search for an instruction document..."
            className="w-full py-3 px-4 pr-10 rounded-full"
          />
          <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
      </div>

      {/* Instructions Card */}
      <div className="bg-white rounded-3xl">
      <div className=" mb-6 bg-white rounded-full p-6">
      <div className="bg-white rounded-xl border p-8 flex justify-between items-center">
          <div>
            <h2 className="text-blue-900 text-xl font-bold mb-2">{vehicleTitle} 2024 Instructions</h2>
            <p className="text-gray-600 text-sm max-w-xs">
              Find clear, step-by-step instructions to help you complete your tasks efficiently and accurately.
            </p>
          </div>
          <img src= {vehicleImage} alt="12M EVS" className="w-27 h-24" />
        </div>
      </div>

      {/* Work Stations Section */}
      <div className="px-6 py-6">
        <h3 className="text-blue-900 font-bold mb-4">Work Stations</h3>
        <div className="space-y-3">
          {workStations.map((station) => (
            <div 
              key={station.id}
              className="bg-sky-200 font-semibold rounded-lg p-4 flex justify-between items-center"
            >
              <span className="text-gray-900">{station.title}</span>
              <ActionDropdown 
              whatComponenr={"workstations"}
            itemId={station.id} 
            itemType={station.type}
            vehicleId = {vehicle?.id}
          />
            </div>
          ))}
        </div>
      </div>
      {/* Bottom Navigation */}
              <BottomNav
              showBack={true}
              />
    </div>
    </div>
  );
};

export default VehicleInstructionsPage;